module.exports = __webpack_public_path__ + "media/images/map_icons/Dodgeball-aa3bba55761d23b2893f99c6912d83f8.svg";